class Parametros {

    ColorFondoTipoTrasaccionManual = "#49dfd0"

}

export default Parametros